<div class="modal-header">
  <h4 class="modal-title">Legenda</h4>
  <button type="button" class="close" aria-label="Chiudi" (click)="activeModal.close()">
    <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
  </button>
</div>
<div class="modal-body">
  <ul class="list-unstyled">
    <li *ngFor="let d of descriptions" class="mb-2">
      <strong>{{ d.title }}:</strong>
      <div>{{ d.text }}</div>
    </li>
  </ul>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="activeModal.close()">Chiudi</button>
</div>